<style lang="scss" scoped>
@import "core";

$my-score-color: lighten(#1c4072, 7%);

.pg-btn-exec {
  display: block;
  width: 80%;
  margin: 10px auto 20px;
}

.pg-score-box {
  font-size: 20px;
  text-align: center;
  line-height: 1.2;
  padding: 20px;
  margin-bottom: 30px;

  @include mq('xs') {
    padding: 10px;
    font-size: 16px;
  }

  dl {
    display: table;
    margin: 0 auto;

    dt {
      display: table-cell;
      vertical-align: middle;
      padding-right: 1em;
    }

    dd {
      display: table-cell;
      vertical-align: middle;
    }
  }
}

.pg-my-score {
  color: $my-score-color;
  font-size: 120%;
  font-weight: bold;
}

.pg-subject {
  margin: 30px 0;

  &:last-child {
    margin-bottom: 0;
  }
}

.pg-subject-table {
  th,
  td {
    width: 25%;
    text-align: left;
    vertical-align: middle;
  }

  @include mq('sp') {
    font-size: 90%;
  }

  @include mq('xs') {
    th,
    td {
      padding-right: 5px;
      padding-left: 5px;
    }
  }
}

.pg-subject-score {
  color: $my-score-color;
  white-space: nowrap;
}

.pg-subject-total {
  font-size: 90%;
  white-space: nowrap;
}
</style>



<template>
  <div class="pg-year">

    <a :href="selfUrl" :target="'_dn_try_old_' + year" class="pg-btn-exec dn-btn dn-btn--primary dn-btn--text-lg">自己採点を入力する</a>

    <div class="pg-score-box dn-box dn-box--gray">
      <dl>
        <dt>総合得点</dt>
        <dd v-if="totalHistory">
          <span class="pg-my-score">{{myTotalScore}}点</span>
          <span class="pg-score-separator">/</span>
          <span class="pg-total-score">{{myTotalMax}}点</span>
        </dd>
      </dl>
    </div>

    <div class="pg-subjects">
      <section
        class="pg-subject"
        v-for="category in categories"
        :key="`categoy_${category.id}`"
      >
        <h2 class="mdTtl02">{{category.name}}</h2>

        <table class="pg-subject-table dn-table">
          <tr
            v-for="row, rowIndex in subjectsForRows(category.subjects)"
            :key="`row_${rowIndex}`"
          >
            <template
              v-for="subject, subjectIndex in row"
            >
              <template v-if="subject.isEmpty">
                <th></th>
                <td></td>
              </template>
              <template v-else>
                <th class="pg-subject-name-cell">{{subject.name}}</th>
                <td class="pg-subject-score-cell">
                  <span class="pg-subject-score">{{getSubjectScoreById(subject.id) || SCORE_EMPTY_STR}}点</span>
                  <span style="white-space: nowrap;">
                    <span class="pg-subject-separator">/</span>
                    <span class="pg-subject-total">{{subject.max}}点</span>
                  </span>
                </td>
              </template>
            </template>
          </tr>
        </table>
      </section>
    </div>
  </div>
</template>



<script>
const SCORE_EMPTY_STR = '***';
const SHOW_COLUMN     = 2;



export default {
  props: {
    year: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      SCORE_EMPTY_STR: SCORE_EMPTY_STR,
      state          : 'pending',
    }
  },

  computed: {
    subjectsStoreName() { return `selfcheck-${this.year}` },
    selfUrl() { return `${this.$store.getters['path/yearRoot'](this.year)}/jikosaiten/index.html` },
    isLoaded() { return this.state === 'loaded' },
    isLoading() { return this.state === 'loading' },
    myTotalScore() { return this.totalHistory.score !== null ? this.totalHistory.score : this.SCORE_EMPTY_STR },
    myTotalMax() { return this.totalHistory.max !== null ? this.totalHistory.max : this.SCORE_EMPTY_STR },
    categories() { return this.isLoaded && this.$store.getters[`${this.subjectsStoreName}/categories`] },
    totalHistory() { return this.isLoaded && this.$store.getters[`${this.subjectsStoreName}/totalHistory`] },
  },

  methods: {
    getSubjectScoreById(id) {
      const history = this.$store.getters[`${this.subjectsStoreName}/subjectHistory`](id);
      return history.fixed && history.selected && history.score;
    },

    /**
     * 科目情報やストレージデータをロードして、visibilityリスナを登録する
     */
    async init() {
      if (this.isLoading || this.isLoaded) return;
      this.state = 'loading';
      await this.$store.dispatch('loadSelfcheck', this.year);
      this.state = 'loaded';
    },



    /**
     * 表示用rowデータを取得する
     */
    subjectsForRows(subjects) {
      const rows = [];
      let rowIndex = -1;

      const _subjects = [];
      subjects.forEach(subject => {
        _subjects.push(subject);
        subject.children.forEach(child => {
          _subjects.push(child);
        });
      });

      _subjects.forEach((subject, index) => {
        if (index % SHOW_COLUMN === 0) rowIndex++;
        let row = rows[rowIndex];
        if (!row) {
          row = [];
          rows[rowIndex] = row;
        }
        row.push(subject);
      });

      const diffCount = SHOW_COLUMN - rows[rowIndex].length;
      for (let i = 0; i < diffCount; i++) {
        rows[rowIndex].push({isEmpty: true});
      }
      return rows;
    },
  },

  created() {
    this.init();
  },
}
</script>



// WEBPACK FOOTER //
// Year.vue?15b9b4cd